import React from "react";
import "./link-social-feed-sidebar.sass";
export const LinkSocialFeedSidebar = ({ href }) => {
  return /* @__PURE__ */ React.createElement("a", { href, target: "_blank", rel: "noopener noreferrer", className: "tint-link-social-feed-sidebar" }, /* @__PURE__ */ React.createElement("span", { className: "fas fa-question" }));
};
